<template>
  <div class="navBer">
    <el-upload
      v-loading="loading"
      :http-request="upload"
      action="#"
      drag
      :limit="limit"
      :disabled="disable"
      :file-list="imgList"
      list-type="picture-card"
      :class="imgList.length >= limit ? 'hide' : 'show'"
      :before-upload="picChange"
    >
      <div slot="default" class="up_class">
        <i class="el-icon-upload" style="font-size: 32px;"></i>
        添加
      </div>

      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disable"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
          <span
            v-if="isPhoneDevice && !disable"
            class="el-upload-list__item-edit"
            @click.stop="handleEditImage(file)"
          >
            <i class="el-icon-edit"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <el-dialog
      :visible.sync="dialogVisible"
      :width="isPhoneDevice?'100vw':'70vh'"
      :modal="false"
      :title="title"
    >
      <div v-if="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import exoprt_file from '@/utils/expor_file'
import { getUploadUrl } from '@/config'

export default {
  components: {},
  props: {
    limit: {
      type: Number,
      default: 1,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    imgListString: {
      type: [String, Array],  // 支持字符串和数组
      default: null,
    },
    mask: {
      type: Boolean,
      default: false,
    },
    isPhone: {
      type: Boolean,
      default: false,
    },
    rowIndex: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      title: '图片详情',
      imgList: [],
      loading: false,
      dialogImageUrl: null,
      dialogVisible: false,
      upUrl: 'index/index/file',
      isPhoneDevice: false,
    }
  },
  watch: {
    imgListString: {
      handler(val) {
        this.initImgList(val)
      },
      immediate: true,
    },
  },
  mounted() {
    this.isPhoneDevice = this.isPhone || this.isMobile()
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'windows phone'];
      return mobileKeywords.some(keyword => userAgent.includes(keyword))
    },
    initImgList(val) {
      let list = []
      this.imgList = []
      if (val) {
        if (typeof val === 'string') {
          list = val.split(',').filter(item => item && item.trim())
        } else if (Array.isArray(val)) {
          list = val
        }
        var arrs = []
        list.forEach((item) => {
          if (item) {
            arrs.push({ url: item })
          }
        })
        this.imgList = arrs
      }
    },
    picChange(file) {
      if (
        file.type == 'image/png' ||
        file.type == 'image/jpeg' ||
        file.type == 'image/jpg'
      ) {
        return true
      } else {
        this.$message({
          type: 'error',
          message: '请上传png/jpg/jpeg格式的图片',
        })
        return false
      }
    },
    upload(file) {
      file = file.file
      var data = {
        file: file,
      }
      this.loading = true
      console.log('上传文件', data)
      exoprt_file(this.upUrl, data).then((res) => {
        console.log(res, '返回路径')
        this.imgList = [...this.imgList, { url: getUploadUrl + res }]
        console.log(this.imgList, 'imgList')
        this.loading = false
        this.emitChange()
      }).catch(() => {
        this.loading = false
        this.$message.error('上传失败')
      })
    },
    handleRemove(file) {
      var url = file.url
      this.imgList.forEach((item, index) => {
        if (url == item.url) {
          this.imgList.splice(index, 1)
        }
      })
      this.emitChange()
    },
    handleEditImage(file) {
      // 确保图片URL有效
      if (!file.url) {
        this.$message.error('图片地址无效')
        return
      }
      
      // 延迟一下，确保父组件准备好
      this.$nextTick(() => {
        this.$emit('editImage', {
          imageUrl: file.url,
          rowIndex: this.rowIndex,
          imgIndex: this.getImageIndex(file.url)
        })
      })
    },
    getImageIndex(url) {
      let index = -1
      this.imgList.forEach((item, i) => {
        if (item.url === url) {
          index = i
        }
      })
      return index
    },
    emitChange() {
      var arr = []
      this.imgList.forEach((item) => {
        arr.push(item.url)
      })
      this.$emit('fileChange', arr)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
  },
}
</script>

<style>
  .el-upload-list__item-thumbnail {
    transition: none !important;
  }
  .murked canvas {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }
</style>

<style scoped lang="scss">
  .pdf {
    position: relative;
  }
  .pdf_meng {
    position: absolute;
    top: 200px;
    left: 200px;
    width: 150px;
    height: 30px;
    z-index: 100;
    background-color: #ccc;
  }

  ::v-deep .el-upload-list__item {
    transition: none !important;
  }
  ::v-deep .el-upload-list__item.is-ready {
    display: none;
  }
  ::v-deep .el-upload-dragger {
    width: 150px;
    height: 90px;
  }
  .el-upload-dragger .el-icon-upload {
    margin-top: 0 ;
  }
  .show {
    display: flex;
    flex-wrap: wrap;
  }
  .navBer::v-deep .el-upload-list--picture-card {
    margin: 0;
    display: block;
    display: contents;
  }

  .navBer::v-deep .el-upload--picture-card {
    width: 150px;
    height: 90px;
    margin-top: 15px;
    border-radius: 8px;
  }
  .navBer::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 150px;
    height: 90px;
    border-radius: 8px;
    margin: 15px 8px 0px 0px;
    border: 1px solid #c0ccda;
    position: relative;
  }

  .navBer::v-deep .el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-edit {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 33%;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    opacity: 0;
    transition: opacity 0.3s;
    cursor: pointer;
  }

  .navBer::v-deep .el-upload-list--picture-card .el-upload-list__item:hover .el-upload-list__item-edit {
    opacity: 1;
  }

  .up_class {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 150px;
    height: 90px;
    line-height: 20px;
  }
  .hide {
    position: relative;
    float: left;
    ::v-deep {
      .el-upload--picture-card {
        display: none;
      }

      .el-upload-list__item {
        border: 0;
        border-radius: 0;
        margin: 0 15px 0 0;
      }
    }
  }
</style>